import { useMemo } from "react";

import type { InsuredTabAdditionalInterest } from "@redux/slices/endorsement";

import { toFormData } from "../utils";

interface UseAdditionalInterestItemParams {
  additionalInterest: InsuredTabAdditionalInterest;
  editingId: string | null;
  onEditClick: (id: string) => void;
  onRemoveClick: (id: string) => void;
}

/** Per-item state and actions for a single additional interest card. */
export const useAdditionalInterestItem = ({
  additionalInterest,
  editingId,
  onEditClick,
  onRemoveClick,
}: UseAdditionalInterestItemParams) => {
  const { additionalInterestId, isBilling } = additionalInterest;

  const isEditing = editingId === additionalInterestId;

  const editingFormData = useMemo(
    () => (isEditing ? toFormData(additionalInterest) : null),
    [isEditing, additionalInterest]
  );

  const actionMenuItems = useMemo(
    () =>
      isBilling
        ? [
            {
              label: "Replace",
              onClick: () => onEditClick(additionalInterestId),
            },
          ]
        : [
            {
              label: "Edit",
              onClick: () => onEditClick(additionalInterestId),
            },
            {
              label: "Remove",
              onClick: () => onRemoveClick(additionalInterestId),
            },
          ],
    [additionalInterestId, isBilling, onEditClick, onRemoveClick]
  );

  return { isEditing, editingFormData, actionMenuItems };
};
